export enum UpdateRecurringEventOption {
  Series = "series",
  OccurrenceDate = "OccurrenceDate",
  FromOccurrenceDate = "FromOccurrenceDate"
}
